const Reflux = require("reflux");
const FinishedActivitiesActions = require("../actions/finished-activities-actions");

const FinishedActivitiesStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      finishedActivities: []
    }
  },

  init: function() {
    this.listenTo(FinishedActivitiesActions.fetchData, this.onFetchStarted);
    this.listenTo(FinishedActivitiesActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(FinishedActivitiesActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        finishedActivities: data.finished_activities
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function(error) {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = FinishedActivitiesStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/finished-activities-store.js